class BusinessUtil {
  constructor(businesses) {
    this.businesses = businesses
  }

  get oc() {
    return this.businesses.find(b => b.borrowerType === 'oc')
  }

  get epc() {
    return this.businesses.find(b => b.borrowerType === 'epc')
  }

  get allCorporateGuarantors() {
    return this.businesses.filter(
      b => b.borrowerType === 'corporate_guarantor'
    )
  }

  get allAffiliates() {
    return this.businesses.filter(b => b.borrowerType === 'affiliate')
  }

  get ocCorporateGuarantors() {
    return this.oc.corporateGuarantors
  }

  get epcCorporateGuarantors() {
    return this.epc.corporateGuarantors
  }
}

export default BusinessUtil
